import { render } from "./BaseInputLabel.vue?vue&type=template&id=46d0ae64&scoped=true"
import script from "./BaseInputLabel.vue?vue&type=script&lang=js"
export * from "./BaseInputLabel.vue?vue&type=script&lang=js"

import "./BaseInputLabel.vue?vue&type=style&index=0&id=46d0ae64&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-46d0ae64"

export default script